<script setup lang="ts">
import { CfgPreloader } from '@cfgtech/ui';

const props = withDefaults(defineProps<{
  isLoading?: boolean;
  columns?: 2 | 3;
}>(), {
  columns: 2
});

const responsive = useResponsive();

const mainContentSize = computed(() => {
  if (responsive.value.desktop && props.columns === 3) {
    return 'col-span-6';
  } else if (responsive.value.desktop && props.columns === 2) {
    return 'col-span-9';
  } else if (!responsive.value.desktop) {
    return 'col-span-12';
  }
});
</script>

<template>
  <div class="flex h-full flex-col">
    <AppNavbar :is-issuer-section-banner-shown="false" />

    <slot v-if="!responsive.desktop" name="secondHeader" />

    <div
      class="grow gap-10 md:grid md:grid-cols-12"
      :class="{
        'container': responsive.desktop,
        'px-3': !responsive.desktop
      }"
    >
      <AppSideBar v-if="responsive.desktop" class="col-span-3 px-3" />

      <template v-if="!isLoading">
        <main
          :class="mainContentSize"
        >
          <slot v-if="responsive.desktop" name="secondHeader" />

          <slot />
        </main>
      </template>

      <template v-else>
        <div
          class="grid items-center justify-center"
          :class="mainContentSize"
        >
          <CfgPreloader class="text-brand" />

          <slot name="loadingText" />
        </div>
      </template>
    </div>

    <AppFooter />
  </div>
</template>
